<div *ngIf="loading" class="loading-screen">
  <div class="spinner">
    <div class="rect1"></div>
    <div class="rect2"></div>
    <div class="rect3"></div>
    <div class="rect4"></div>
    <div class="rect5"></div>
    <h6 class="text">{{text}}</h6>
  </div>
</div>